export default __webpack_public_path__ + "static/media/green-planet.9dc3923d.svg";